import { Component, OnInit } from '@angular/core';
import { config } from '../../../config.prod';

@Component({
  selector: 'ngx-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {
  serverUrl = config.serverUrl;
  constructor() { }

  ngOnInit() {
  }

}
